import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ensureMailNotificationSW } from './utils/desktopNotifications';

// Früh registrieren, damit Windows-Toasts über den SW gehen können
if (typeof window !== 'undefined' && window.isSecureContext !== false) {
  ensureMailNotificationSW();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
